import styled from 'styled-components';
import { StyledWishlistButtonProps } from './WishlistButton.types';

export const StyledWishlistButton = styled.button<StyledWishlistButtonProps>`
  background: none;
  border: 0;

  display: flex;
  align-items: center;
  cursor: pointer;

  .wishlist-button__label {
    margin-left: 5px;
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
  }

  ${(props) => props.customStyle}
`;
